import Vue from 'vue'
import App from './App.vue'
import router from './router'
import loading from 'vant/lib/loading'
import 'vant/lib/loading/style'
import { Toast } from 'vant';
import 'vant/lib/toast/style'
import 'vant/lib/password-input/style'
import 'vant/lib/number-keyboard/style'
Vue.config.productionTip = false

Vue.use(Toast);
Vue.use(loading)
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
